// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Title_wrapper__3JhVz","is_overflowing":"Title_is_overflowing__1_EcF","title":"Title_title__2oC4S","is_primary":"Title_is_primary__2T_eG"};